export default __webpack_public_path__ + "static/media/Sign.031ca955.png";